import baseRoute from '../baseRoute';

export default `${baseRoute}/materialCost` as const;
